<template>
  <div class="supplier-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "supplierBase",
};
</script>
